export default `
<div class="color_code">
  <div class="selection">
    <div id="top-left" class="color"></div>
    <div id="top-right" class="color"></div>
    <div id="bottom-left" class="color"></div>
    <div id="bottom-right" class="color"></div>
  </div>
  <div class="choices">
    <div class="color"></div>
    <div class="color"></div>
    <div class="color"></div>
    <div class="color"></div>
    <div class="color"></div>
    <div class="color"></div>
  </div>
</div>
<p data-translate="connectPopupContent" class="center"></p>
`;
